import {awaitApi} from "../../Utility/services";
import {values} from "lodash";
import dayjs from 'dayjs';

export function handleChatEvent(stuff) {
  globalThis.CHAT_EVENTS ||= [];
  let now = dayjs().format("HH:mm:ss");

  globalThis.CHAT_EVENTS.push(Object.assign({t: now}, stuff));
}

export function tryTrapChatEvents({config}) {
  return awaitApi({
    getApi: () => {
      let w = globalThis.F9?.Chat?.Wrapper;
      return w && w.messenger ? w : null;
    },
    callback: api => trapChatEvents({config, api})
  });
}

function trapChatEvents({config, api}) {
  globalThis.CHAT_EVENTS ||= [];

  // api is F9.Chat.Wrapper,
  let {Events, messenger} = api;

  if (!messenger) {
    console.error("error, no F9 messenger")
  }
  let eventList = values(Events);
  for (let eventName of eventList) {
    //console.log(`TRAP EVENT: ${eventName}`)
    messenger.on(eventName, payload => handleChatEvent({eventName, payload}));
  }
  console.log("trapped events: " + _.join(_.sortBy(eventList), ", "))
}

export function analyseChatEvents(events) {
  let x = {open: false, chatting: false};

  for (let e of events) {
    let {eventName, payload} = e;
    if (eventName == 'widget:opened')
      x.open = true;
    if (eventName == 'widget:closed')
      x.open = false;
    if (eventName == "messenger:sent")
      x.chatting = true;
    if (eventName == "messenger:received")
      x.chatting = true;
    if (eventName == "conversationCreated")
      x.chatting = true;
    if (eventName == "conversationTerminated")
      x.chatting = false;
  }
  return x;
}
